// TODO: Remove this Controller since it is deprecated. The Course / Lesson Videos now use the Ramsey Plus Components React Player.
// All other videos in "Explore" section are using media-player-controller.js

import { Controller } from '@hotwired/stimulus';
import { enableDoneButtonIfLastIncompleteItem } from '../utils/enable_done_button_if_last_incomplete_item';
import VideoPlayerEventEmitter from '../video/video_player_event_emitter';

/**
 * @deprecated Deprecated: use "media-player" controller instead.
 */
export default class VideoController extends Controller {
  static targets = ['actionItem', 'progressBar'];
  isHiddenClass = 'is-hidden';

  static values = {
    videoContentType: String,
    currentActionItemIndex: Number,
    playerId: String,
    videoUrl: String,
    captionsUrl: String,
    previewImage: String,
    interactionUrl: String,
    position: Number,
    completionTime: Number,
    disableProgress: Boolean
  };

  get progressBar() {
    return this.progressBarTarget;
  }

  initialize() {
    this.element[this.identifier] = this;
  }

  connect() {
    this.videoContentTypeValue = 'application/x-mpegURL';
    this.createPlayer();
  }

  createPlayer() {
    /* eslint-disable no-undef */
    // this is coming in from the main application. Need to assume it exists for now.
    this.player = jwplayer(this.playerIdValue);
    /* eslint-enable no-undef */

    const tracks = [];
    if (this.hasCaptionsUrlValue) {
      // vtt file path is determined in the model, based on the video url
      tracks.push({
        kind: 'captions',
        file: this.captionsUrlValue,
        label: 'English'
      });
    }

    this.player.setup({
      file: this.videoUrlValue,
      image: this.previewImageValue,
      aspectratio: '16:9',
      playbackRateControls: true,
      horizontalVolumeSlider: true,
      cast: {},
      tracks: tracks
    });

    if (this.disableProgressValue) {
      return;
    }

    this.playerEventEmitter = VideoPlayerEventEmitter(this.player, {
      position: this.positionValue,
      contentType: this.videoContentTypeValue,
      eventHandler: this.playerEventCallback.bind(this)
    });
    this.playerEventEmitter.initialize();
  }

  async playerEventCallback(payload) {
    this.hideProgressBar(payload.action);

    const response = await fetch(this.interactionUrlValue, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    if (response.status === 200) {
      this.playerProgressSuccess(payload.position);
    }
  }

  playerProgressSuccess(savedPosition) {
    if (savedPosition >= this.completionTimeValue) {
      this.fireCompleteEvent();
      enableDoneButtonIfLastIncompleteItem();
      if (this.actionItemTargets.length >= 1) {
        const target = this.actionItemTargets[this.currentActionItemIndexValue];
        if (target.dataset.completed === 'false') {
          target.dataset.completed = true;
        }
      }
    }
  }

  hideProgressBar(action) {
    if (action === 'play') {
      this.progressBar.classList.add(this.isHiddenClass);
    }
  }

  fireCompleteEvent() {
    const completeEvent = new CustomEvent('rpwa_completed_lesson_video', {});
    document.dispatchEvent(completeEvent);
  }
}
